import GeneratedPageHost from "./generated/GeneratedPageHost";

const PageView: React.FC<{ data?: any }> = ({ data }) => {
  return <GeneratedPageHost data={data} />;
};

export default PageView;
